import { Input, message } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import {
  approveVacation,
  getVacationRequestDetail,
} from '../../../api/aops.vacation.api'
import { userState } from '../../../store/user'
import AopsCommonModalLayout from '../modal/AopsCommonModalLayout'
const returnLeaveType = () => {
  return [
    { label: '연차', value: 'DAY' },
    { label: '반차', value: 'HALF' },
    { label: '반반차', value: 'QUARTER' },
  ]
}
const returnTimeSlot = () => {
  return [
    { label: '종일', value: 'ALL' },
    { label: '오전', value: 'AM' },
    { label: '오후', value: 'PM' },
  ]
}
const AopsVacationDetailModal = ({
  open = false,
  onClose,
  title = '연차 신청',
  setShouldRefresh,
  selectedHistoryId,
  selectedName,
  shouldRefresh,
}) => {
  const [user] = useRecoilState(userState)
  const [formData, setFormData] = useState({
    name: '',
    targetDate: '',
    leaveType: '연차',
    timeSlot: '종일',
    description: '',
  })

  const resetForm = () => {
    setFormData({
      name: '',
      targetDate: '',
      leaveType: '연차',
      timeSlot: '종일',
      description: '',
    })
    onClose()
  }
  useEffect(() => {
    if (!open) resetForm()
  }, [open])

  const fetchVacationRequestDetail = async () => {
    try {
      const res = await getVacationRequestDetail(selectedHistoryId)
      setFormData({
        name: res.userName,
        targetDate: res.targetStartDate,
        leaveType: res.leaveType,
        timeSlot: res.timeSlot,
        description: res.description,
      })
    } catch (error) {
      console.error('Failed to fetch vacation request detail:', error)
    }
  }
  useEffect(() => {
    if (open) {
      fetchVacationRequestDetail()
    }
  }, [open])
  const handleApproveVacation = async () => {
    const param = {
      status: 'APPROVED',
      adminComment: '',
    }
    setShouldRefresh(false)
    try {
      const res = await approveVacation(selectedHistoryId, param)
      message.success('연차 승인이 완료되었습니다.')
      setShouldRefresh(true)
      resetForm()
    } catch (error) {
      console.error('Failed to approve vacation:', error)
      message.error('연차 승인에 실패했습니다.')
    }
  }
  return (
    <AopsCommonModalLayout
      open={open}
      onClose={onClose}
      title={title}
      width={'50%'}
    >
      <div className="form-container">
        <div className="form-wrapper">
          <div className="form-section">
            <label className="form-label">이름</label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="이름"
                value={selectedName}
                className="form-input"
                rows={4}
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">사용 일자</label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="사용 일자"
                value={dayjs(formData.targetDate).format('YYYY-MM-DD')}
                className="form-input"
                rows={4}
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">연차 종류</label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="연차 종류"
                value={
                  returnLeaveType().find(
                    (item) => item.value === formData.leaveType,
                  )?.label
                }
                className="form-input"
                rows={4}
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">시간 대</label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="시간 대"
                value={
                  returnTimeSlot().find(
                    (item) => item.value === formData.timeSlot,
                  )?.label
                }
                className="form-input"
                rows={4}
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">휴가 사유</label>
            <div style={{ width: '100%' }}>
              <Input.TextArea
                placeholder="사유"
                value={formData.description}
                className="form-textarea"
                style={{ fontWeight: 600 }}
                rows={4}
                readOnly={true}
              />
            </div>
          </div>
        </div>

        <div className="popup-footer">
          <button className="btn-cancel" onClick={onClose}>
            취소
          </button>
          <button className="btn-submit" onClick={handleApproveVacation}>
            승인 완료
          </button>
        </div>
      </div>
    </AopsCommonModalLayout>
  )
}
export default AopsVacationDetailModal
